import { useDraggable } from "@dnd-kit/core";
import { Card } from "components/Card";

export function Draggable({ id, content, styles, title }) {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id,
  });

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      }
    : {};

  return (
    <div
      ref={setNodeRef}
      style={{
        minWidth: 100,
        minHeight: 40,
        background: "#f0f0f0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
        ...styles,
      }}
    >
      <Card
        style={{
          width: "440px",
          height: "230px",
          border: "1px solid black",
          boxShadow: "2px 2px 5px rgba(0,0,0,0.5)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <button
            {...listeners}
            {...attributes}
            style={{
              cursor: "grab",
              touchAction: "none",
              zIndex: 1000,
              padding: "2px 6px",
              border: "none",
              borderRadius: "2px",
              marginLeft: "4px",
            }}
            aria-label="Drag"
          >
            ☰
          </button>
          <span style={{ fontWeight: "bold", fontSize: "1.1em" }}>{title}</span>
        </div>
        {content}
      </Card>
    </div>
  );
}
